module.exports = __webpack_public_path__ + "static/media/zo.814cd644.png";